import React from 'react';
import { CalendarChip } from './CalendarChip.jsx';

/** A read-only calendar event in the schedule band. */
export function EventRow({
  time = 'ALL DAY', calendar, monogram, accent, title, stale = false,
  onClick, divider = false, style
}) {
  const timed = time !== 'ALL DAY';
  return (
    <div onClick={onClick} style={{
      display: 'flex', gap: 'var(--bujo-space-3)', alignItems: 'center', minHeight: 36,
      borderBottom: divider ? '1px solid var(--bujo-rule-hairline)' : 'none',
      opacity: stale ? 0.72 : 1,
      cursor: onClick ? 'pointer' : 'default', ...style
    }}>
      <span style={{
        width: 'var(--bujo-time-col)', flex: 'none',
        font: `${timed ? 'var(--bujo-fw-medium)' : 'var(--bujo-fw-regular)'} var(--bujo-fs-micro)/var(--bujo-lh-tight) var(--bujo-font-mono)`,
        color: timed ? 'var(--bujo-text-primary)' : 'var(--bujo-text-meta)'
      }}>{time}</span>
      <CalendarChip name={calendar} monogram={monogram} accent={accent} />
      <span style={{
        flex: 1, minWidth: 0,
        font: 'var(--bujo-fw-regular) var(--bujo-fs-event)/var(--bujo-lh-row) var(--bujo-font-mono)',
        color: stale ? 'var(--bujo-text-dim)' : 'var(--bujo-text-primary)',
        textWrap: 'pretty'
      }}>{title}</span>
    </div>
  );
}
